// extracted by mini-css-extract-plugin
module.exports = {"Emojis__item":"bfw_a bht_vc bht_rm bht_wf"};